// Plain-language messages for sign-in failures. Returns "" when nothing should be shown (the person closed the popup).
export const authErrorText = (error) => {
  if (error instanceof TypeError) {
    // fetch() rejects with a TypeError when the server can't be reached.
    return "We couldn't reach the server. Check your internet connection and try again.";
  }
  switch (error?.code) {
    case "auth/invalid-credential":
    case "auth/invalid-login-credentials":
    case "auth/wrong-password":
    case "auth/user-not-found":
    case "auth/invalid-email":
      return "That email and password don't match. Check them and try again, or reset your password.";
    case "auth/too-many-requests":
      return "Too many attempts. Wait a few minutes and try again, or reset your password.";
    case "auth/user-disabled":
      return "This account has been disabled. Contact Vavetek support.";
    case "auth/network-request-failed":
      return "We couldn't reach the server. Check your internet connection and try again.";
    case "auth/popup-blocked":
      return "Your browser blocked the sign-in window. Allow pop-ups for this site and try again.";
    case "auth/popup-closed-by-user":
    case "auth/cancelled-popup-request":
    case "auth/user-cancelled":
      return "";
    default:
      return "Something went wrong while signing in. Please try again.";
  }
};

/** Posts the Firebase ID token to a backend login endpoint. Throws (with `status`) unless it answers success. */
export const backendLogin = async (path, idToken) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
  });
  const json = await response.json().catch(() => ({}));
  if (!response.ok || !json.success) {
    const error = new Error("Login failed");
    error.status = response.status;
    throw error;
  }
  return json;
};

/** Text for the sign-in method(s) an existing account uses, for "account exists with different credential". */
export const existingMethodText = (methods) => {
  if (methods.includes("password")) return "your email and password";
  if (methods.includes("google.com")) return "Google";
  if (methods.includes("microsoft.com")) return "Microsoft";
  return "the method you used before";
};
